export const BILLING_TYPES = {
    UPDATE_CLAIM_LEVEL_BILLING_STATUS:"UPDATE_CLAIM_LEVEL_BILLING_STATUS"
   }